import { render, staticRenderFns } from "./LoadingDocsIADialogComponent.vue?vue&type=template&id=6434e862&scoped=true"
import script from "./LoadingDocsIADialogComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingDocsIADialogComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoadingDocsIADialogComponent.vue?vue&type=style&index=0&id=6434e862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434e862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6434e862')) {
      api.createRecord('6434e862', component.options)
    } else {
      api.reload('6434e862', component.options)
    }
    module.hot.accept("./LoadingDocsIADialogComponent.vue?vue&type=template&id=6434e862&scoped=true", function () {
      api.rerender('6434e862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/LoadingDocsIADialogComponent.vue"
export default component.exports